__turbopack_context__.v({
  "mobileHidden": "QXpeUG_mobileHidden",
  "underlineHover": "QXpeUG_underlineHover",
});
